"use client";
import React from "react";
import PropTypes from "prop-types";
import { Divider, Label } from "semantic-ui-react";
import dynamic from "next/dynamic";

const Link = dynamic(() => import("react-scroll").then((mod) => mod.Carousel), {
  ssr: false,
});
import {
  Ecomment,
  ButtonItem,
  Title,
  Segmant,
  InText,
  QuesFeed,
  Wcomment,
  NewInText,
  NewEcomment,
  NewWcomment,
} from "../../components";

import { customdecodeURIComponent } from "../../common/Utils";

const CommentList = ({
  commentData,
  display,
  click,
  visibility,
  toggle,
  change,
  show,
  replies,
  rplylike,
  queslike,
  onLike,
  changeval,
  submit,
  value,
  rlike_queid_qc_index,
  totstate,
  askques,
  ...props
}) => {
  let max = commentData.length;

  let data = display ? commentData.slice(0, max) : commentData.slice(0, 3);
  let length = 3;
  return (
    <div
      style={{ marginTop: 20, marginLeft: 20 }}
      key={Math.floor(Math.random() * 100) + 1}
    >
      {data.map((comment, index) => (
        <div key={index}>
          {comment.userId.length > 0 ? (
            <QuesFeed
              date={comment.postedDate}
              data={customdecodeURIComponent(comment.question)}
              name={
                "(" +
                (comment.userId[0].type === "realtor"
                  ? comment.userId[0].realEstateFirm
                    ? comment.userId[0].realEstateFirm
                    : "Realtor"
                  : comment.userId[0].type) +
                ")"
              }
              username={
                comment.userId.length > 0
                  ? comment.userId[0].displayname &&
                    comment.userId[0].displayname !== "" &&
                    comment.userId[0].type !== "realtor"
                    ? comment.userId[0].displayname
                    : `${comment.userId[0].firstName} ${comment.userId[0].lastName}`
                  : ""
              }
              userid={
                comment.userId[0].type === "realtor" ? comment.userId[0].id : ""
              }
            />
          ) : (
            <QuesFeed
              date={comment.postedDate}
              data={customdecodeURIComponent(comment.question)}
              name=""
              username={
                comment.userId.length > 0
                  ? comment.userId[0].displayname &&
                    comment.userId[0].displayname !== "" &&
                    comment.userId[0].type !== "realtor"
                    ? comment.userId[0].displayname
                    : `${comment.userId[0].firstName} ${comment.userId[0].lastName}`
                  : ""
              }
            />
          )}
          <div style={{ textAlign: "center" }}>
            <Link
              to={"id_" + comment.id}
              activeClass="active"
              spy={true}
              smooth={true}
              offset={-100}
              duration={500}
              href="#"
            >
              <span className="reply_blue_btn">
                <ButtonItem
                  basic
                  id={"btn_" + comment.id}
                  icon="comment outline"
                  content="Reply"
                  onClick={(e) => toggle(e, comment.id, e)}
                  customclass="blue"
                  {...props}
                />
              </span>
            </Link>
          </div>
          <div style={{ marginLeft: 20 }}>
            <div key={index}>
              {!comment.replies ? null : comment.replies.length <= length ? (
                <div className="que_replies_blk">
                  {comment.replies.map((data, index) => (
                    <NewEcomment
                      answerId={data.id}
                      source={
                        data.userimage &&
                        data.userimage !== undefined &&
                        data.userimage !== "$context.arguments.userimage"
                          ? data.userimage
                          : process.env.NEXT_PUBLIC_CDN_ID +
                            "static/images/userdefault.png"
                      }
                      name={
                        data &&
                        (data.displayname == null || data.displayname == "") &&
                        data.type != "realtor"
                          ? data.firstName +
                            " " +
                            data.lastName +
                            " " +
                            (data.type === "realtor" ? data.realEstateFirm : "")
                          : data && data.displayname
                      }
                      //name={comment.userId[0].firstName+' '+comment.userId[0].lastName+', '+ (comment.userId[0].type === 'realtor' ? comment.userId[0].realEstateFirm : comment.userId[0].type)}
                      date={data.postedDate}
                      text={customdecodeURIComponent(data.message)}
                      visibility={visibility}
                      helpcontent={data.helpfulCount}
                      helpStatus={data.helpStatus}
                      rplylike={rplylike}
                      onLike={onLike}
                      totdata={data}
                      key1={index}
                      queid={comment.id}
                      rlike_queid_qc_index={
                        "rlike_" + comment.id + "_qc_" + index
                      }
                      totstate={totstate}
                      key={index}
                      userid={data.type === "realtor" ? data.replyuserid : ""}
                      usertype={
                        data.realEstateFirm != ""
                          ? data.realEstateFirm
                          : data.type
                      }
                    />
                  ))}
                  {!visibility[comment.id] ? (
                    <Divider
                      style={{
                        border: "1px solid #DEDEDE",
                        margin: "0 0 1.5em 3em",
                        maxWidth: 600,
                      }}
                    />
                  ) : (
                    ""
                  )}
                </div>
              ) : show[index] ? (
                <div className="que_replies_blk">
                  {comment.replies.slice(0, 10).map((data, index) => (
                    <NewEcomment
                      answerId={data.id}
                      source={
                        data.userimage &&
                        data.userimage !== undefined &&
                        data.userimage !== "$context.arguments.userimage"
                          ? data.userimage
                          : process.env.NEXT_PUBLIC_CDN_ID +
                            "static/images/userdefault.png"
                      }
                      name={
                        data &&
                        (data.displayname == null || data.displayname == "") &&
                        data.type != "realtor"
                          ? data.firstName +
                            " " +
                            data.lastName +
                            " " +
                            (data.type === "realtor" ? data.realEstateFirm : "")
                          : data && data.displayname
                      }
                      date={data.postedDate}
                      text={customdecodeURIComponent(data.message)}
                      visibility={visibility}
                      helpcontent={data.helpfulCount}
                      helpStatus={data.helpStatus}
                      rplylike={rplylike}
                      onLike={onLike}
                      totdata={data}
                      key1={index}
                      queid={comment.id}
                      rlike_queid_qc_index={
                        "rlike_" + comment.id + "_qc_" + index
                      }
                      totstate={totstate}
                      userid={data.type === "realtor" ? data.replyuserid : ""}
                      usertype={
                        data.realEstateFirm != "" ? data.realEstateFirm : ""
                      }
                    />
                  ))}
                  <span
                    style={{
                      display: "inline-block",
                      cursor: "pointer",
                      width: "100%",
                      marginLeft: 43,
                    }}
                    onClick={(e) => replies(e, index)}
                  >
                    <Title
                      name="Hide replies"
                      color="blue"
                      size="small"
                      floated="left"
                    />
                  </span>
                  {!visibility[comment.id] ? (
                    <Divider
                      style={{
                        border: "1px solid #DEDEDE",
                        margin: "0 0 1.5em 3em",
                        maxWidth: 600,
                      }}
                    />
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                <div className="que_replies_blk">
                  {comment.replies.length > length ? (
                    <div className="que_replies_blk">
                      {comment.replies.slice(0, 3).map((data, index) => (
                        <NewEcomment
                          answerId={data.id}
                          source={
                            data.userimage &&
                            data.userimage !== undefined &&
                            data.userimage !== "$context.arguments.userimage"
                              ? data.userimage
                              : process.env.NEXT_PUBLIC_CDN_ID +
                                "static/images/userdefault.png"
                          }
                          name={
                            data &&
                            (data.displayname == null ||
                              data.displayname == "") &&
                            data.type != "realtor"
                              ? data.firstName +
                                " " +
                                data.lastName +
                                " " +
                                (data.type === "realtor"
                                  ? data.realEstateFirm
                                  : "")
                              : data && data.displayname
                          }
                          date={data.postedDate}
                          text={customdecodeURIComponent(data.message)}
                          visibility={visibility}
                          helpcontent={data.helpfulCount}
                          helpStatus={data.helpStatus}
                          rplylike={rplylike}
                          onLike={onLike}
                          totdata={data}
                          key1={index}
                          queid={comment.id}
                          rlike_queid_qc_index={
                            "rlike_" + comment.id + "_qc_" + index
                          }
                          totstate={totstate}
                          userid={
                            data.type === "realtor" ? data.replyuserid : ""
                          }
                          usertype={
                            data.realEstateFirm != ""
                              ? data.realEstateFirm
                              : data.type
                          }
                        />
                      ))}
                      <span
                        style={{
                          display: "inline-block",
                          cursor: "pointer",
                          width: "100%",
                          marginLeft: 43,
                        }}
                        onClick={(e) => replies(e, index)}
                      >
                        <Title
                          name="Show Previous replies"
                          color="blue"
                          size="small"
                          floated="left"
                        />
                      </span>
                      {!visibility[comment.id] ? (
                        <Divider
                          style={{
                            border: "1px solid #DEDEDE",
                            margin: "0 0 1.5em 3em",
                            maxWidth: 600,
                          }}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  ) : null}
                </div>
              )}
            </div>
          </div>
          <div
            style={{ marginLeft: 20 }}
            id={"id_" + index}
            className="question_section"
          >
            <NewWcomment
              name="onreply"
              questionId={comment.id}
              change={change}
              visibility={visibility[comment.id]}
              changeval={(e) => changeval(e, index)}
              submit={(e) => submit(e)}
              value={value[index]}
              form="reply"
              buttonName="Reply"
              placeholder="Add a reply ..."
              userimage={
                totstate &&
                totstate.user_info &&
                totstate.user_info.length > 0 &&
                totstate.user_info[0].userimage !== undefined
                  ? totstate.user_info[0].userimage
                  : ""
              }
              key={index}
              autoFocus
              onFocus={function (e) {
                var val = e.target.value;
                e.target.value = "";
                e.target.value = val;
              }}
              // userimage={""}
            />

            {visibility[comment.id] ? (
              <Divider
                style={{
                  border: "1px solid #828282",
                  margin: "2em 0 1.5em 3em",
                  maxWidth: 600,
                }}
              />
            ) : null}
            <div style={{ clear: "both" }}></div>
          </div>
        </div>
      ))}

      {display ? (
        <span
          style={{ display: "inline-block", cursor: "pointer", width: "100%" }}
          onClick={(e) => click(e)}
        >
          <Title
            name="Show Less Questions"
            color="blue"
            size="small"
            floated="right"
            id="reply_box"
          />
        </span>
      ) : commentData.length > 3 ? (
        <span
          style={{ display: "inline-block", cursor: "pointer", width: "100%" }}
          onClick={(e) => click(e)}
        >
          <Title
            name="Show More Questions"
            color="blue"
            size="small"
            floated="right"
            id="reply_box"
          />
        </span>
      ) : (
        ""
      )}
      {/* <ButtonItem
        size="small"
        className="btn_blue_bg"
        icon
        labelPosition="right"
        floated="left"
        onClick={(e) => askques(e)}
      >
        Ask a Question
      </ButtonItem> */}
      <ButtonItem
        as="div"
        labelPosition="right"
        floated="left"
        onClick={(e) => askques(e)}
        className="theme_blue btn_blue"
      >
        <ButtonItem
          //color="#1b57a5"
          icon="write"
          className="btn_blue_bg"
        />
        <Label
          as="a"
          name="saveNeighbor"
          content="Ask a Question"
          basic
          //color="#1b57a5"
          pointing="left"
          className="theme_blue btn_blue"
        />
      </ButtonItem>
      {data == [] || data.length <= 0 ? (
        <div className="no_ques_blk">
          <h3>Be the first to ask a Question!</h3>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

CommentList.propTypes = {
  commentData: PropTypes.array.isRequired,
};

export default CommentList;
